import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why everything must change every five years",
  "description": "",
  "published": "2018-02-23T00:00:00.000Z",
  "redirect_from": ["/blog/why-everything-must-change-every-five-years/swizec/8212"],
  "categories": "Opinions, Personal, Thoughts",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/02/change.jpg",
        "alt": null
      }}></img></p>
    <p>{`You complain about `}<a parentName="p" {...{
        "href": "https://www.google.com/search?q=javascript+fatigue&oq=javascript+fatigue&aqs=chrome..69i57j0l3.2712j0j1&sourceid=chrome&ie=UTF-8"
      }}>{`JavaScript fatigue`}</a>{`, and that's valid. The ecosystem moves fast, and it's hard to keep up. Dare I say impossible?`}</p>
    <p>{`But won't you think of the authors and the conferences and the speakers and the trainers and video course makers and everyone else working hard to teach you all the new things?`}</p>
    <p>{`A whole industry relies on new things coming out to confuse you!`}</p>
    <p>{`Why, if you're not confused about that new feature, who will come to our talks? Who are we going to teach?`}</p>
    <p>{`If a new framework doesn't come out to boil the ocean and replace everything that existed before it, who is going to buy the hundreds of books and video courses that we want to make?`}</p>
    <p>{`You can't make more sales if there's nothing new to sell. If you can't make more sales, how are you gonna pay rent? Hosting fees? Vacations in Bali?`}</p>
    <p>{`Sure –– hundreds, even thousands of people enter the field every day. People change jobs and become software engineers. People go from one type of engineering to another. People grow up and get their first jobs.`}</p>
    <p>{`The field is growing, and that's a good thing. You can sell your conferences and your books and your courses to the newcomers.`}</p>
    <p>{`But wouldn't it be nice if you could also sell them to everybody else? There's a lot more of everybody else.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.bls.gov/ooh/computer-and-information-technology/software-developers.htm"
      }}>{`Software Engineering is growing at about 24% per decade`}</a>{`. You can't build a training industry on that. Not a big one anyway.`}</p>
    <p><img parentName="p" {...{
        "src": "/ab6a9831970ac812dc36a5fe1f8b0c58/media-cEYFeDKVPTmRgIG9fmo-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`There's a whole other 76%! You can sell stuff to them.`}</p>
    <p>{`But you first need to get them confused.`}</p>
    <p>{`Invent a new frontend framework. Say that tables are bad and CSS rules all. 10 years later, turn CSS into tables. Double whammy!`}</p>
    <p>{`Create new bundlers and compilers and tell everyone that JavaScript must be compiled – it's really much better that way. Invent a whole new way to talk to backends because REST and Ajax are lame.`}</p>
    <p>{`Don't tell anyone that all these things are pretty much the same as always behind the scenes. You still need Ajax to talk to the backend, everything still turns into HTML in the end, and CSS still winds up a bunch of `}<inlineCode parentName="p">{`<style>`}</inlineCode>{` tags no matter what bundler you use. 🤫`}</p>
    <p>{`It's the oldest play in the book. Invent something new, convince everyone it's better, watch a cottage industry spring up around it. Training, consulting, all the things.`}</p>
    <p>{`But really, we're all at the mercy of this. Sometimes, I think the big companies just have too many engineers with nothing to do so they keep coming up with new things.`}</p>
    <p>{`¯`}{`\\`}{`_`}{`(ツ)`}{`_`}{`/¯`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      